import { Game } from "shared/games/types/Game";
import { GameQuestion } from "shared/games/types/GameQuestions";
import IsThisCompOn from "./Comp/IsThisCompOn/IsThisCompOn";
import FrequencyFinders from "./EQ/FrequencyFinder/FrequencyFinder";
import CanYouPan from "./Pan/CanYouPan/CanYouPan";
import FaderGrader from "./Volume/FaderGrader/FaderGrader";
import MixPuzzle from "./MixPuzzle";
import { homePage } from "routes";

interface Props {
  question: GameQuestion;
  onRequestNext: () => void;
  exitUrl?: string;
  navbarContextTitle: string;
  referenceTrackDisabled?: boolean;
}

export default function GameController({
  question,
  onRequestNext,
  exitUrl = homePage,
  referenceTrackDisabled,
  navbarContextTitle,
}: Props) {
  if (
    question.type === Game.freq_finder_boost ||
    question.type === Game.freq_finder_cut ||
    question.type === Game.freq_finder_hipass ||
    question.type === Game.freq_finder_lopass
  ) {
    return (
      <FrequencyFinders
        navbarContextTitle={navbarContextTitle}
        question={question}
        onRequestNext={onRequestNext}
        referenceTrackDisabled={referenceTrackDisabled}
      />
    );
  }

  if (question.type === Game.is_this_compressor_on) {
    return (
      <IsThisCompOn
        navbarContextTitle={navbarContextTitle}
        question={question}
        onRequestNext={onRequestNext}
        referenceTrackDisabled={referenceTrackDisabled}
      />
    );
  }

  if (question.type === Game.fader_grader) {
    return (
      <FaderGrader
        navbarContextTitle={navbarContextTitle}
        question={question}
        onRequestNext={onRequestNext}
        referenceTrackDisabled={referenceTrackDisabled}
      />
    );
  }

  if (question.type === Game.can_you_pan) {
    return (
      <CanYouPan
        navbarContextTitle={navbarContextTitle}
        question={question}
        onRequestNext={onRequestNext}
        referenceTrackDisabled={referenceTrackDisabled}
      />
    );
  }

  if (question.type === Game.mixPuzzle) {
    return (
      <MixPuzzle
        navbarContextTitle={navbarContextTitle}
        question={question}
        onRequestNext={onRequestNext}
        referenceTrackDisabled={referenceTrackDisabled}
      />
    );
  }

  return null;
}
